import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-complaint-sent-page',
  templateUrl: './complaint-sent-page.component.html',
  styleUrls: ['./complaint-sent-page.component.scss']
})
export class ComplaintSentPageComponent  {
  constructor(private location: Location) {}

  

  back() {
    this.location.back();
  }
}
